import { registerDecorators as _registerDecorators, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./radioGroup.html";
import { OptionsInput } from '../common/common';
class RadioGroup extends OptionsInput {
  constructor(...args) {
    super(...args);
    this.starsLabel = '';
    this.focusOnInitialize = false;
    this.enableRadioDeselect = void 0;
    this.isMouseClick = false;
    this._hasRendered = false;
  }
  get inputType() {
    return this.multiple ? 'checkbox' : 'radio';
  }

  // @ts-expect-error * Automated Type Error Fix
  handleChange(event) {
    event.stopPropagation();
    this.optionSelected();
  }
  handleMouseUp() {
    this.isMouseClick = true;
  }

  /* handle deselection of radio buttons */
  // @ts-expect-error * Automated Type Error Fix
  handleClick(event) {
    this.optionSelected(event.currentTarget.value);
  }
  get radioOptions() {
    return this.transformedOptions.map(option => ({
      ...option,
      ...this.starsForOption(option),
      isBaseLabel: option.type !== 'stars' && option.type !== 'badge'
    }));
  }
  starsForOption(option) {
    if (option.type === 'stars') {
      const starsLabel = Number(option.value) < 5 ? this.starsLabel : '';
      return {
        stars: option.value,
        starsLabel
      };
    }
    return {};
  }
  renderedCallback() {
    if (this._hasRendered) {
      return;
    }
    this._hasRendered = true;
    if (!this.focusOnInitialize) {
      return;
    }

    // If we're a list of checkboxes, focus the first input,
    // if we're a radio group, focus the selected input,
    // or the first input if there is no selection.
    if (this.multiple) {
      this.template.querySelector('input')?.focus();
    } else {
      const checkboxes = Array.from(this.template.querySelectorAll('input'));
      const checkedElements = checkboxes.filter(checkBoxButton => checkBoxButton.checked);

      // If we have a selected element, select that, otherwise select the first input
      if (checkedElements.length > 0) {
        checkedElements[0]?.focus();
      } else {
        checkboxes[0]?.focus();
      }
    }
  }

  // @ts-expect-error * Automated Type Error Fix
  optionSelected(currentTargetValue) {
    const checkedElements = Array.from(this.template.querySelectorAll('input')).filter(checkBoxButton => checkBoxButton.checked);
    const prevCheckedItem = this.transformedOptions.filter(item => item.checked);
    if (!this.multiple && this.enableRadioDeselect && prevCheckedItem.length && prevCheckedItem[0].value === currentTargetValue) {
      // @ts-expect-error * Automated Type Error Fix
      this.value = null;
    } else {
      this.value = checkedElements.map(element => element.value);
    }

    // Re-Dispatch Event
    this.dispatchEvent(new CustomEvent('change', {
      detail: {
        value: this.value,
        clicked: this.isMouseClick
      },
      composed: true,
      bubbles: true,
      cancelable: true
    }));
    this.isMouseClick = false;
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(RadioGroup, {
  publicProps: {
    starsLabel: {
      config: 0
    },
    focusOnInitialize: {
      config: 0
    },
    enableRadioDeselect: {
      config: 0
    }
  },
  fields: ["isMouseClick", "_hasRendered"]
});
const __lwc_component_class_internal = _registerComponent(RadioGroup, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;